<template>
  <div class="page">
    <router-view/>
  </div>
</template>

<script>
import AppTop from '@/components/TopPage.vue'

export default {
  name: 'AppPage',
  components: {
    AppTop,
  },
  props: ['isBoss'],
  data() {
    return {
      periodSelected: '4 недели',
    };
  },
  created() {
      document.title = "Сервис планирования баннерного размещения Amway";
  },
  mounted() {
    this.$store.dispatch('get_types');
    this.$store.dispatch('get_tags');
    this.$store.dispatch('get_vendors');
    this.$store.dispatch('get_languages');
    this.$store.dispatch('get_platforms');
  }
}
</script>

<style lang="scss" scoped>

</style>
    